import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { mdiChevronDown, mdiChevronUp, mdiFormTextbox } from '@mdi/js';
import { docTableActionsCallbacks as docTableActions } from './DocTableActions';
import { labelFontSemiBold, vars } from '../../../Theme';
import AppTooltip from '../AppTooltip/AppTooltip';
import ContextMenu from '../ContextMenu/ContextMenu';
import Icon from '@mdi/react';

export default ({
    replicaId,
    documentId,
    value,
}: {
    replicaId: string;
    documentId: string;
    value: string;
}) => {
    const { t } = useTranslation('translations', { keyPrefix: 'categoryAutomatic' });
    const chevronRef = useRef<HTMLButtonElement>();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const onEditClick = () => {
        setAnchorEl(null);
        docTableActions.editDocumentNumber({ replicaId, universalId: documentId });
    };

    const contextMenuOption = () => (
        <Stack key={`option-${value}`} direction='row' sx={{ width: '100%' }}>
            <ListItem sx={{ p: '2px 12px' }}>
                <ListItemText
                    primary={
                        <Typography
                            variant='body2'
                            sx={{
                                fontSize: 12,
                            }}
                        >
                            {value}
                        </Typography>
                    }
                    secondary={
                        <Typography
                            sx={{
                                ...labelFontSemiBold,
                                fontSize: '16px',
                                color: vars.font,
                                fontWeight: 500,
                            }}
                        >
                            {value.split('\\').pop()}
                        </Typography>
                    }
                />
            </ListItem>
            <AppTooltip title={t('editDocNumber')}>
                <IconButton
                    onClick={onEditClick}
                    sx={{ width: '34px', height: '34px', margin: 'auto' }}
                >
                    <Icon path={mdiFormTextbox} color={vars.font} size={1.0} />
                </IconButton>
            </AppTooltip>
        </Stack>
    );

    const contextMenu = () => (
        <>
            <IconButton
                ref={chevronRef}
                onClick={() => setAnchorEl(chevronRef.current)}
                sx={{ p: '5px' }}
            >
                <Icon path={anchorEl ? mdiChevronUp : mdiChevronDown} size={1.0} />
            </IconButton>
            <ContextMenu
                sx={{ '& .MuiList-root': { padding: '0px' } }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {contextMenuOption()}
            </ContextMenu>
        </>
    );

    return value ? (
        <Stack
            direction='row'
            sx={{
                alignItems: 'center',
                width: '100%',
            }}
        >
            <AppTooltip title={value}>
                <Typography
                    variant='body2'
                    sx={{
                        width: '100%',
                        fontSize: 14,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        paddingRight: '12px',
                    }}
                >
                    {value}
                </Typography>
            </AppTooltip>
            {contextMenu()}
        </Stack>
    ) : (
        <></>
    );
};
